<template>
    <div class="container">
        <home-tabs></home-tabs>
        <home-online-bar></home-online-bar>
        <home-consult-total></home-consult-total>
        <home-notice></home-notice>
        <home-ycjy></home-ycjy>
    </div>
</template>

<script>
  import HomeTabs from "../components/home/tabs";
  import HomeOnlineBar from "../components/home/online-bar";
  import HomeConsultTotal from "../components/home/consult-total";
  import HomeNotice from "../components/home/notice";
  import HomeYcjy from "../components/home/ycjy";

  export default {
    name: "home",
    components: {HomeYcjy, HomeNotice, HomeConsultTotal, HomeOnlineBar, HomeTabs}
  }
</script>

<style scoped>

</style>
